import styles from '@ui/components/Switch/Switch.module.scss';
import React, { forwardRef } from 'react';
import { Checkbox } from '@ariakit/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Switch = forwardRef(
  ({ disabled = false, store = null, ...props }, ref) => (
    <div
      className={classNames(styles.switch, {
        [styles.disabled]: disabled,
      })}
    >
      <Checkbox
        className={styles.checkbox}
        disabled={disabled}
        ref={ref}
        store={store}
        {...props}
      />
      <div className={styles.knobs} />
      <div
        className={classNames(styles.layer, {
          [styles.disabled]: disabled,
        })}
      />
    </div>
  ),
);

Switch.propTypes = {
  disabled: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  /** `useCheckboxStore()` return value from the `@ariakit/react` */
  store: PropTypes.object,
};

Switch.displayName = 'Switch';

export default Switch;
